export const META_SERIE_SEPARATOR = '_';

export const createMetaSerieId = (originalId: string, serieIndex: number) =>
  `${originalId}${META_SERIE_SEPARATOR}${serieIndex}`;

export const getOriginalSerieId = (serieId: string) => serieId.split(META_SERIE_SEPARATOR)[0];
